<template>
  <section class="file-download">
    <div class="file-download__wrapper">
      <a :class="{'disabled' : disabled}" class="ws-button file-download-button button is-text is-small is-size-3 has-text-left" @click.stop="openFile({ download:true })">
        <span class="file-download-button__label" v-if="buttonLabel">{{ buttonLabel }}&nbsp;</span>
        <span class="file-download-button__file-name" v-if="isShowFileName">
          <strong>{{ file.file_name }}</strong>
        </span>
        <span class="file-download-button__size" v-if="isShowFileSize">&nbsp;({{ prettyBytes(file.file_size) }})</span>
        <span class="file-download-button__date" v-if="isShowFileDate">&nbsp;
            <ws-time-formatter :date="file.created_at" format="LL" />
        </span>
        <span class="file-download-button__spinner" v-if="isOpeningFile">
          &nbsp;<ws-spinner />
        </span>
      </a>
      <button
        type="button"
        class="ws-button button is-text is-small is-size-5"
        :disabled="disabledTrue ? disableDelete : disabled || disableDelete"
        @click="removeFile()">
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="false"
          width="17"
          height="11"
        />
      </button>
    </div>
  </section>
</template>

<script>
import saveAs from 'file-saver'
import prettyBytes from '@/filters/prettyBytes'
import { mapActions } from 'vuex'
export default {
  name: 'FileDownload',
  props: {
    file: {
      type: Object,
      default: null
    },
    label: {
      type: String
    },
    buttonLabel: {
      type: String,
      default: 'Скачать'
    },
    isShowFileName: {
      type: Boolean,
      default: true
    },
    isShowFileDate: {
      type: Boolean,
      default: false
    },
    isShowFileSize: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    disableDelete: Boolean,
    disabledTrue: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpeningFile: false
    }
  },
  methods: {
    ...mapActions('profile/files', {
      getFileById: 'getFileById'
    }),
    prettyBytes,
    async openFile (options) {
      if (this.disabled) return
      this.isOpeningFile = true
      try {
        const file = await this.getFileById({
          'file-guid': this.file.guid
        })
        if (file && file.redirect_to) {
          if (options && options.download) {
            const _file = await fetch(`${file.redirect_to}`, { method: 'get' })
            saveAs(await _file.blob(), this.file.file_name)
          } else {
            window.location.href = file.redirect_to
          }
        }
      } catch (e) {
        // console.log(e)
      }
      this.isOpeningFile = false
    },
    async removeFile () {
      this.$emit('remove', { file: this.file })
    }
  }
}
</script>

<style lang="scss">
  .file-download {
    &__wrapper {
      overflow: hidden;
      display: grid;
      grid-template-columns: minmax(auto, calc(100% - 40px)) 40px;
    }
    &-button {
      // display: flex;
      // flex-direction: row;
      justify-content: left;
      &__file-name {
        display: block;
        white-space: nowrap;
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
      }
    }
  }
  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
